// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-header {
  min-height: 60px;
  display: flex;
  align-items: center;
}
.contacts-header .contacts-header-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
}
.contacts-header .contacts-lastupdate {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.contacts-header .contacts-search-box {
  color: #6A8991;
  font-size: 17px;
  display: flex;
  align-items: center;
}
.contacts-header .contacts-search-box .load-contacts-file-input {
  font-size: 18px;
  color: #6A8991;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.contacts-header .contacts-search-box .contacts-search-input {
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 17px;
  color: #6A8991;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Contacts/Contacts.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;AACD;AACC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;AAEC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAF;AAGC;EACC,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AADF;AAGE;EACC,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AADH;AAIE;EACC,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAFH","sourcesContent":[".contacts-header {\n\tmin-height: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\n\t.contacts-header-buttons {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tmargin-right: 20px;\n\t}\n\n\t.contacts-lastupdate {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t}\n\n\t.contacts-search-box {\n\t\tcolor: #6A8991;\n\t\tfont-size: 17px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.load-contacts-file-input {\n\t\t\tfont-size: 18px;\n\t\t\tcolor: #6A8991;\n\t\t\tcursor: pointer;\n\t\t\twhite-space: nowrap;\n\t\t\tuser-select: none;\n\t\t}\n\n\t\t.contacts-search-input {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t\toutline: 0;\n\t\t\tfont-size: 17px;\n\t\t\tcolor: #6A8991;\n\t\t\theight: 30px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
